import { Link, useSearchParams } from "react-router-dom";
import { Button } from "@/components/ui/button";
import { CheckCircle2, Mail } from "lucide-react";
import Header from "@/components/Header";
import Footer from "@/components/Footer";

export default function ThankYou() {
  const [params] = useSearchParams();
  const type = params.get("type") || "course";
  const isWaitlist = type === "waitlist";

  return (
    <div data-testid="thank-you-page" className="bg-white min-h-screen flex flex-col text-ink">
      <Header />
      <main className="flex-1 grid place-items-center px-6 pt-32 pb-20">
        <div className="max-w-2xl w-full text-center">
          <div className="inline-flex items-center justify-center w-16 h-16 rounded-full bg-brand-soft border border-brand/20 mb-8">
            <CheckCircle2 className="text-brand" size={28} />
          </div>
          <div className="font-mono-spec text-[11px] uppercase tracking-[0.22em] text-brand mb-4 font-medium">{isWaitlist ? "You're on the list" : "You're officially in"}</div>
          <h1 className="font-display text-4xl sm:text-5xl lg:text-6xl tracking-[-0.035em] text-ink leading-[1.05]">
            You&apos;re officially one step closer to{" "}
            <span className="font-serif-em italic text-brand font-light">building smarter.</span>
          </h1>
          <p className="mt-6 text-lg text-ink/70 leading-relaxed">
            {isWaitlist
              ? "We've saved your spot on the waitlist. When seats open, you'll be the first to know."
              : "Confirmation is on its way. The Zoom link for the live build lab will be emailed to you a few days before June 23, 2026 at 7:00 PM EST."}
          </p>
          <div className="mt-10 p-6 rounded-2xl bg-bone border border-[var(--line)] text-left flex gap-4 items-start">
            <Mail size={20} className="text-brand mt-1 shrink-0" />
            <div>
              <div className="text-ink font-semibold">Check your inbox</div>
              <div className="text-sm text-ink/65 mt-1">
                We just sent your confirmation. If it doesn&apos;t arrive in 5 minutes, check spam or promotions.
              </div>
            </div>
          </div>
          <div className="mt-10">
            <Link to="/" data-testid="thank-you-home-link">
              <Button variant="outline" className="btn-outline-ink rounded-full h-12 px-6 font-medium">
                Back to Home
              </Button>
            </Link>
          </div>
        </div>
      </main>
      <Footer />
    </div>
  );
}
